import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonModule } from '@fino-ui/button';
import { BaseModalComponent } from '@fino-ui/modal';
import { TranslationModule } from '@fino-ui/translation';

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.sass'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslationModule, ButtonModule],
})
export class VideoModalComponent extends BaseModalComponent<object, void> {
  constructor() {
    super();
    Object.assign(this, this.data ?? {});
  }
}
